var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BED5FC"
    },
    d: "M709.766,182.674c-11.428-33.294-46.238-56.419-82.787-64.689 c-36.549-8.27-75.234-3.282-111.314,6.607c-28.073,7.694-55.213,18.322-80.744,31.618c-20.203,10.522-39.62,22.802-61.577,29.648 c-24.429,7.617-51.393,8.042-76.087,1.2c-24.86-6.888-46.761-20.683-70.513-30.375c-26.337-10.746-54.839-16.377-83.464-19.012 c-27.376-2.52-57.734-1.477-78.464,15.324c-12.033,9.753-19.235,23.708-23.931,37.887c-8.151,24.61-9.247,52.625,4.536,74.964 c16.923,27.428,52.218,40.402,85.91,44.858c33.692,4.456,68.306,2.446,101.485,9.479c36.747,7.789,69.697,26.211,101.909,44.393 c12.511,7.062,25.037,14.139,38.142,20.2c59.706,27.614,131.051,32.72,194.606,13.928 c47.729-14.113,91.447-41.941,118.923-80.846C713.873,278.954,724.983,227.005,709.766,182.674z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BED5FC"
    },
    d: "M165.565,351.823c-15.227-1.749-27.909-0.992-43.148,0.689 c-15.239,1.681-30.482,7.205-39.379,17.321c-10.497,11.935-10.293,28.655-2.208,41.754c8.086,13.098,23.026,22.817,39.437,29.062 c26.155,9.952,60.708,10.637,80.938-6.028c9.073-7.474,14.253-17.66,15.923-28.031c2.175-13.509-1.665-27.936-12.391-38.461 C194.01,357.603,184.577,353.635,165.565,351.823L165.565,351.823z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BED5FC"
    },
    d: "M636.82,70.144c-2.64,2.629-2.92,7.001-0.924,10.147c1.996,3.146,5.415,5.064,8.762,6.699 c4.992,2.438,10.148,4.539,15.422,6.283c6.939,2.295,16.042,3.305,20.204-2.703c2.636-3.805,1.967-9.213-0.624-13.049 c-2.591-3.836-6.743-6.335-10.996-8.161C659.527,65.437,645.492,61.508,636.82,70.144z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E62C8"
    },
    d: "M148.136,332.076h74.507c1.689,0,3.059-1.37,3.059-3.059v-99.714c0-1.689-1.37-3.059-3.059-3.059 h-74.507c-1.689,0-3.059,1.369-3.059,3.059v99.714C145.077,330.706,146.447,332.076,148.136,332.076z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#738999"
    },
    points: "269.131,464.638 259.381,464.638 246.006,344.638 264.756,344.638  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A53AD"
    },
    d: "M140.182,344.638h121.165c1.024,0,1.855-0.831,1.855-1.855v-21.415 c0-1.024-0.83-1.855-1.855-1.855H140.182c-1.024,0-1.855,0.83-1.855,1.855v21.415 C138.327,343.808,139.158,344.638,140.182,344.638z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96AABC"
    },
    points: "138.327,464.638 148.077,464.638 161.452,344.638 142.702,344.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#738999"
    },
    points: "161.452,464.638 171.202,464.638 184.577,344.638 165.827,344.638  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#343741"
    },
    cx: 250.523,
    cy: 120.615,
    r: 11.382
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M230.49,80.565c8.663,0.579,16.85,4.571,22.248,11.371c2.546,3.207,4.785,7.359,5.588,12.515 c2.25,14.438-9.375,29.813-9.375,29.813s-2.063,11.438-9.188,16.125s-16.875,1.875-16.875,1.875l2.063,11.438 c0,0,1.888,0.232,4.544,0.766c7.279,1.462,8.583,11.341,1.946,14.667c-3.824,1.917-8.604,3.382-14.365,3.504 c-10.372,0.221-18.665-4.818-23.735-9.002c-2.917-2.407-2.441-6.999,0.93-8.714l4.243-2.159l3.75-23.813 c0,0-9.938-9.75-7.125-22.125C197.58,106.083,206.379,78.952,230.49,80.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M222.889,152.263c0,0-5.125-2.063-8.188-5.188c0,0,0.135,7.163,9.38,11.8L222.889,152.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343741"
    },
    d: "M202.264,138.951l0.844-9.891c0,0-5.531-1.172-5.156-6.703c0.375-5.531,5.344-11.25,9.281-8.906 c3.938,2.344,1.594,12.48,1.594,12.48l2.813,0.756l11.074-13.776c0,0,1.301,5.602,6.926,4.946 c5.625-0.656,5.719-4.946,5.719-4.946s1.031,5.04,5.813,4.946c4.781-0.094,5.156-2.156,5.156-2.156s-0.375,5.289,6.656,5.551 c7.031,0.262,6.75-5.645,6.75-5.645s7.469,0.031,6.719-9.094s-5.25-8.25-5.25-8.25s7.063-2.25,4.063-12.375 s-12.187-7.313-12.187-7.313s0.063-9.75-8.688-12s-12.688,5.813-12.688,5.813s-4.579-8.105-13.446-6.209 c-8.867,1.896-7.929,11.084-7.929,11.084s-9.375-6.938-16.313-0.75s-1.688,14.438-1.688,14.438s-10.688-0.75-11.813,10.5 s8.063,13.182,8.063,13.182s-6.375,5.849-2.438,14.428c3.938,8.578,9.563,8.24,9.563,8.24S197.951,141.951,202.264,138.951z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M235.889,134.576 l-0.688,2.625c0,0,1.25,2.625-0.375,3.438s-3.125-0.75-3.125-0.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M224.045,137.3l7.125,8.289c0,0-5,3.813-9,0.625S224.045,137.3,224.045,137.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.045,137.3c0,0-0.628,0.613-1.333,1.548c0.605,2.071,2.251,5.459,6.64,7.79 c1.103-0.505,1.817-1.049,1.817-1.049L224.045,137.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 227.755,
    cy: 124.132,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 247.931,
    cy: 133.632,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M236.359,128.157c0,0,1.909-0.241,2.782,1.87"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M229.541,127.301c-0.453,1.315-1.619,2.106-2.606,1.766c-0.986-0.339-1.419-1.681-0.966-2.996 c0.453-1.315,1.619-2.106,2.605-1.766C229.561,124.645,229.994,125.986,229.541,127.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343741",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M226.357,120.763 c0,0,3.281-0.75,5.344,1.125"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M246.174,133.356c-0.453,1.315-1.619,2.106-2.605,1.766c-0.986-0.34-1.419-1.681-0.966-2.996 c0.453-1.315,1.619-2.106,2.605-1.766C246.194,130.699,246.627,132.041,246.174,133.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343741",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M245.67,127.701 c0,0,2.438,0.918,3.563,2.719"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M205.639,120.201 c0,0,0.469-3.094-1.031-3.094s-4.781,5.719-1.406,7.875"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M312.447,452.59l25.634,6.048l-1.75,6h-53.25l2.983-11.533 C296.702,459.019,307.968,454.771,312.447,452.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M304.127,450.151l-2.313-6.763h-15.612l0.453,7.438l0,0l-0.59,2.279 c10.638,5.914,21.904,1.666,26.383-0.515L304.127,450.151z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323A43"
    },
    d: "M250.451,318.888l17.73,124.5h36.77l3.75-136c0,0-6.77-17.5-30.385-17.5 C241.701,289.888,250.451,318.888,250.451,318.888z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1B2126"
    },
    points: "285.525,443.4 286.201,306.388 288.877,443.376  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323A43"
    },
    d: "M294.567,452.59l25.634,6.048l-1.75,6h-53.25l2.983-11.533 C278.822,459.019,290.088,454.771,294.567,452.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M286.643,450.268l-2.317-6.88h-15.375v6.75l-0.767,2.967 c10.638,5.914,21.904,1.666,26.383-0.515L286.643,450.268z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E62C8"
    },
    d: "M196.326,167.763c0,0,8.775,9.747,20.75,8.75c11.975-0.997,16-8.75,16-8.75l-4.047,78.125 h-20.953L196.326,167.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M198.514,162.763c0,0-19.313,5.389-27.063,19.882c-7.75,14.493-5.316,37.993,8.967,60.243 c0,0-23.783,72,0,79s70.105,0,70.105,0s8.178-28,35.678-15.5c0,0,8.5-7.5,22.5,1c0,0-2-23.956-13.5-28.228 c-11.5-4.272-54-11.466-54-11.466l-1.75-8.806l30.5-7l-2.25-15.25l-29.793,1.5l-0.77-6.375c0,0,10.688-1.688,10.313-9.188 s-2-18.75-2-18.75l28.625,35.313l57.875,12.75l6-10.75l-52.573-21.438l-27.423-39.298c-4.828-6.343-11.559-10.974-19.208-13.216 l-9.333-2.736l-2.473,73.687h-15.115L198.514,162.763z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC6CE"
    },
    d: "M180.418,242.888c1.491,2.588,2.977,5.167,4.605,7.655c1.593,2.504,3.262,4.957,5.066,7.278 c1.828,2.274,3.762,4.558,6.085,6.061c0.579,0.36,1.173,0.675,1.77,0.846c0.149,0.038,0.298,0.094,0.445,0.121l0.438,0.054 c0.307,0.03,0.692-0.003,1.035,0c0.695,0.012,1.432-0.073,2.156-0.13c0.724-0.048,1.457-0.15,2.188-0.239 c2.928-0.33,5.863-0.796,8.794-1.276c2.938-0.445,5.863-0.99,8.802-1.462c5.865-1.021,11.748-1.991,17.65-2.908 c-5.734,1.676-11.518,3.159-17.35,4.44c-5.835,1.279-11.687,2.447-17.663,3.192c-0.749,0.083-1.494,0.179-2.258,0.222 c-0.762,0.052-1.508,0.131-2.305,0.113c-0.402-0.008-0.765,0.024-1.198-0.018l-0.67-0.093 c-0.217-0.044-0.421-0.116-0.632-0.175c-0.432-0.105-0.788-0.316-1.182-0.476c-0.353-0.205-0.725-0.398-1.05-0.631 c-1.331-0.91-2.447-1.999-3.477-3.135c-1.032-1.136-1.955-2.344-2.825-3.581C185.378,253.792,182.681,248.415,180.418,242.888z "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 195.15,163.918 193.264,190.888 200.526,195.686 199.639,210.388 208.545,219.559  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 233.076,165.524 237.908,188.638 231.554,197.138 234.731,209.451 227.564,219.559  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M268.181,239.888l9.833-8.875l3.75,2.438l-2.472,5.863c0,0,8.097-4.175,16.722-11.3l6.563,6.75 c0,0-8.813,21.75-31.875,16.313L268.181,239.888z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 198.514,
    y1: 162.763,
    x2: 211.826,
    y2: 238.138
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 229.413,
    y1: 164.451,
    x2: 226.941,
    y2: 238.138
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC6CE"
    },
    d: "M237.908,238.138c-2.726,0.193-5.451,0.288-8.177,0.425c-2.726,0.129-5.451,0.208-8.177,0.288 c-5.451,0.143-10.902,0.24-16.354,0.261l-0.693,0.003l-0.23-0.666c-1.177-3.407-2.325-6.824-3.445-10.25 c-1.147-3.417-2.219-6.859-3.324-10.291c-1.067-3.444-2.136-6.887-3.155-10.348c-0.997-3.467-2.018-6.927-2.936-10.421 c1.38,3.339,2.656,6.713,3.956,10.078c1.279,3.373,2.506,6.763,3.736,10.152c1.193,3.402,2.418,6.793,3.567,10.209 c1.177,3.407,2.325,6.824,3.446,10.25l-0.923-0.663c5.451,0.021,10.902,0.118,16.354,0.261 c2.726,0.079,5.451,0.158,8.177,0.288C232.457,237.85,235.183,237.945,237.908,238.138z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M199.962,170.965 c0,0,6.243,5.804,15.741,5.614c9.498-0.19,13.454-4.488,13.454-4.488"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M337.353,242.209c0,0,13.973-2.008,25.598,4.93l-2.063,4.75l-18.562-3.063l0.75,3.063 l-10.338-1.411L337.353,242.209z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M589.323,332.076h-74.507c-1.689,0-3.059-1.37-3.059-3.059v-99.714 c0-1.689,1.369-3.059,3.059-3.059h74.507c1.689,0,3.059,1.369,3.059,3.059v99.714 C592.382,330.706,591.012,332.076,589.323,332.076z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#738999"
    },
    points: "468.328,464.638 478.078,464.638 491.453,344.638 472.703,344.638  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8F1F9"
    },
    d: "M597.277,344.638H476.112c-1.024,0-1.855-0.831-1.855-1.855v-21.415 c0-1.024,0.83-1.855,1.855-1.855h121.165c1.024,0,1.855,0.83,1.855,1.855v21.415 C599.132,343.808,598.301,344.638,597.277,344.638z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96AABC"
    },
    points: "599.132,464.638 589.382,464.638 576.007,344.638 594.757,344.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#738999"
    },
    points: "576.007,464.638 566.257,464.638 552.882,344.638 571.632,344.638  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323A43"
    },
    d: "M546.632,263.138c0,0,10.5,23.573,9.75,49.801s-23.25,28.101-75.375,11.709l-6.375,125.491 h-17.625h-19.125c0,0-17.552-138.136-8.552-156.402c9-18.265,67.802-12.645,67.802-12.645l2.25-17.953H546.632z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M455.336,450.28l-7.501-98.06l-3.751-49.031c-0.351-4.154,0.383-8.425,2.271-12.152 c1.858-3.703,5.013-6.933,9.045-8.199c4.017-1.065,8.108-1.455,12.199-1.758c4.093-0.276,8.193-0.364,12.29-0.38 c-4.096,0.103-8.192,0.277-12.27,0.64c-4.063,0.382-8.17,0.878-12.06,1.989c-3.843,1.279-6.822,4.429-8.553,8.032 c-1.759,3.627-2.395,7.749-1.988,11.747l4.552,48.962l9.105,97.926L455.336,450.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M497.204,280.537c4.89,0.743,9.765,1.539,14.633,2.391c4.866,0.858,9.726,1.763,14.545,2.847 c-4.856-0.901-9.741-1.622-14.631-2.295c-4.89-0.667-9.791-1.278-14.691-1.834L497.204,280.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M455.899,453.105l-0.767-2.967h-17.25l-8.366,2.452 C433.995,454.771,445.261,459.019,455.899,453.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M429.516,452.59l-25.634,6.048l1.75,6h53.25l-2.983-11.533 C445.261,459.019,433.995,454.771,429.516,452.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M473.779,453.105l-0.767-2.967h-17.25l-8.366,2.452 C451.875,454.771,463.141,459.019,473.779,453.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323A43"
    },
    d: "M447.396,452.59l-25.634,6.048l1.75,6h53.25l-2.983-11.533 C463.141,459.019,451.875,454.771,447.396,452.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343741"
    },
    d: "M554.755,119.845c-8.348-15.48-10.009-21.824-10.009-21.824l-56.865,1.944 c0,0,4.624,39.943-3.814,56.63c0,0,4.003,1.178,10.493,2.417c0.757-2.132,2.026-6.301,2.07-10.417c0,0,0.939,6.695,0.303,10.852 c1.551,0.272,3.209,0.542,4.967,0.796c0.53-1.21,1.197-2.974,1.542-4.836c0,0,0.766,2.942,0.857,5.164 c12.35,1.599,28.693,2.275,44.171-1.553c1.195-2.617,3.084-7.578,2.472-11.731c0,0,0.898,6.034,0.349,10.978 c1.734-0.496,3.453-1.049,5.151-1.67C556.443,156.595,563.103,135.325,554.755,119.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M492.093,94.299c-1.245,2.755-5.089,13.074,0.351,25.714c0,0,0,26.25,19.313,26.813l2.625,16.313 c0,0-9.745,2.012-18.272,5.279c-6.505,2.492-7.976,11.033-2.658,15.533c6.636,5.615,17.449,11.688,33.18,11.688 c15.81,0,25.777-7.158,31.598-13.735c4.895-5.531,2.619-14.301-4.394-16.622c-4.176-1.382-9.831-2.833-17.454-4.142v-24 c0,0,4.25-7.75,4-16c0,0,6.25,0,4-9s-5.25-31.75-27.5-31.75c-17.976,0-23.114,9.779-24.195,12.495 C492.497,93.361,492.305,93.831,492.093,94.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M511.757,146.826c0,0,5.375,1.313,15-2.313c0,0-4.368,5.894-14.184,7.384L511.757,146.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343741"
    },
    d: "M543.571,108.293c0.692,1.303,2.343-0.253,2.741-1.674c0.121-0.432,0.082-0.89,0.034-1.336 c-1.157-10.73-7.517-20.777-16.72-26.413c-1.805-1.105-3.73-2.056-5.793-2.529c-1.663-0.381-3.381-0.444-5.088-0.47 c-5.937-0.088-12.05,0.303-17.432,2.812c-6.394,2.981-11.303,8.976-12.964,15.833l0,0c-0.563,3.009-1.213,6.436,0.572,8.923 c0.813,1.132,2.006,1.923,3.187,2.663c3.058,1.916,6.36,3.709,9.962,3.935c-0.822-1.968-1.21-4.115-1.131-6.246 c5.717,4.348,13.069,5.768,20.133,7.064c-0.655-1.886-1.542-3.691-2.636-5.362c2.936,1.73,5.997,3.345,9.321,4.099 c3.324,0.754,6.972,0.572,9.922-1.133c1.486-0.859,3.153-2.13,4.719-1.429L543.571,108.293z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M511.757,138.013l7.5-6.036c0,0,5.125,6.661,2.375,8.411S511.757,138.013,511.757,138.013z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M519.257,131.977l-7.5,6.037c0,0,0.944,0.544,2.27,1.153c1.899-0.676,4.459-1.991,6.991-4.495 C520.169,133.168,519.257,131.977,519.257,131.977z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M500.164,123.565c0.238,1.37-0.402,2.626-1.43,2.804c-1.028,0.178-2.054-0.788-2.291-2.158 c-0.238-1.37,0.402-2.626,1.43-2.804C498.901,121.229,499.926,122.195,500.164,123.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343741",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M493.757,117.841 c0,0,0.984-1.922,4.313-2.203"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B2126"
    },
    d: "M517.927,119.655c0.238,1.37-0.402,2.626-1.43,2.804c-1.028,0.178-2.054-0.788-2.292-2.158 c-0.238-1.37,0.402-2.626,1.43-2.804S517.689,118.285,517.927,119.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343741",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M513.441,112.965 c0,0,3.469-0.328,5.25,1.219"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M511.757,133.065 c-7.996,3.274-4.407-7.241-4.407-7.241l-0.803-3.686"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M539.764,118.326 c0,0,3.721-6.281,1.334-7.875c-2.387-1.594-3.043,4.289-3.043,4.289"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M576.075,208.326l10.829,103.217c0,0,9.184,3.529,12.424,5.929 c3.24,2.4,4.227,18.917,4.227,18.917l-5.264-1.412l-4.69-11.294l-9.972-4.05c0,0,0.754,5.462,2.002,7.862l-4.333,0.988 c0,0-4.914-8.717-5.339-11.258c-0.425-2.541,0.669-7.094,0.669-7.094s-9.426-27.926-10.165-49.301l-12.068-42.347 L576.075,208.326z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M490.757,216.973l-18.375,25.915l-66.75,9h-11l1.5-2.5l-18.75,2.5l-1.5-4.5l6.75-3.25 c11.25-4.75,25,0.75,25,0.75c46.5-17.25,54.538-18.75,54.538-18.75l9.212-20C471.382,206.138,483.632,209.308,490.757,216.973z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323A43"
    },
    d: "M462.17,226.138c0,0-2.656,0.499-13.657,4.164l6.024,14.992l17.845-2.406l7.546-10.643 l-15.498-10.534L462.17,226.138z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323A43"
    },
    points: "333.882,239.888 306.382,245.294 306.382,251.888 339.382,251.888 336.382,239.888  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#323A43",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M335.382,244.826h26.625 c7.663,0,13.875-6.212,13.875-13.875v-9.125c0-8.664,7.023-15.688,15.688-15.688h8.313c4.832,0,8.75,3.917,8.75,8.75l0,0 c0,5.178,4.197,9.375,9.375,9.375h2.969c6.817,0,12.344-5.527,12.344-12.344v-8.023c0-7.059,5.722-12.781,12.781-12.781l0,0 c7.059,0,12.781,5.722,12.781,12.781v23.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E62C8"
    },
    d: "M494.451,169.078c0,0,8.431,18.435,30.681,16.373c22.25-2.063,31.436-19.199,31.436-19.199 s12.62,7.985,23.252,43.949h0c-7.479,5.844-16.43,9.501-25.861,10.566l-1.076,0.122l-1.5-10.25l-4.75,52.5 c0,0-19.25,10.25-47.25,0l-2-33.805c0,0-4.362-9.445-2.931-22.945l-3.694,14.5c0,0-11.25-10.5-22.125-12.563 C468.632,208.326,485.132,171.888,494.451,169.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M494.451,169.078 c0,0,6.556,18.06,30.681,16.373c24.125-1.688,31.436-19.199,31.436-19.199"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M491.319,168.951 c0,0,5.38,23.25,34.19,22.125c28.81-1.125,34.435-24.824,34.435-24.824"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M514.382,163.138 c0,0,4.5,6.375,11.25,5.625s10.75-7.625,10.75-7.625"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M552.882,220.888 c0,0,13.625,0.75,26.938-10.688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M468.632,208.326 c0,0,11.25,0.938,22.125,12.563"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M499.144,259.123 c0,0,26.214,9.734,47.851,0"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96AABC"
    },
    points: "481.206,464.638 489.706,464.638 463.882,263.45 445.382,263.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96AABC"
    },
    points: "285.899,464.638 277.399,464.638 303.223,263.45 321.723,263.45  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.007,
    y: 251.888,
    style: {
      fill: "#E8F1F9"
    },
    width: 213.75,
    height: 11.561
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M402.589,125.276c0-5.488-4.449-9.938-9.938-9.938c-5.488,0-9.938,4.449-9.938,9.938v11.204 h19.875V125.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M382.714,136.48v11.041c0,5.488,4.449,9.938,9.938,9.938c5.488,0,9.938-4.449,9.938-9.938V136.48 H382.714z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10
    },
    x1: 440.257,
    y1: 390.388,
    x2: 438.757,
    y2: 390.388
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10,
      strokeDasharray: "2.8027,2.8027"
    },
    x1: 435.954,
    y1: 390.388,
    x2: 398.118,
    y2: 390.388
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10
    },
    x1: 396.717,
    y1: 390.388,
    x2: 395.217,
    y2: 390.388
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 375.882,
    y: 380.638,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 771.2634 780.7762)",
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    width: 19.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E62C8",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 381.257,
    y1: 386.076,
    x2: 389.6,
    y2: 394.419
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E62C8",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 389.6,
    y1: 386.076,
    x2: 381.257,
    y2: 394.419
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10
    },
    x1: 578.975,
    y1: 290.451,
    x2: 580.475,
    y2: 290.451
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10,
      strokeDasharray: "2.8027,2.8027"
    },
    x1: 583.278,
    y1: 290.451,
    x2: 621.114,
    y2: 290.451
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10
    },
    x1: 622.515,
    y1: 290.451,
    x2: 624.015,
    y2: 290.451
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 623.85,
    y: 280.701,
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    width: 19.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E62C8",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 629.428,
    y1: 286.279,
    x2: 637.772,
    y2: 294.623
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2E62C8",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 637.772,
    y1: 286.279,
    x2: 629.428,
    y2: 294.623
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10
    },
    x1: 539.976,
    y1: 238.138,
    x2: 541.476,
    y2: 238.138
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10,
      strokeDasharray: "2.9081,2.9081"
    },
    x1: 544.384,
    y1: 238.138,
    x2: 601.093,
    y2: 238.138
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeMiterlimit: 10
    },
    x1: 602.547,
    y1: 238.138,
    x2: 604.047,
    y2: 238.138
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 603.882,
    y: 228.388,
    style: {
      fill: "none",
      stroke: "#1B2126",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    width: 19.5,
    height: 19.5
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2E62C8",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 609.221,238.622 612.753,242.154 618.971,234.122  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.132,
    y: 102.925,
    style: {
      fill: "#5C87CC"
    },
    width: 69.5,
    height: 102.059
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 104.835,
    cy: 117.372,
    r: 6.516
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 137.724,
    x2: 126.632,
    y2: 137.724
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 143.132,
    x2: 126.632,
    y2: 143.132
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 148.541,
    x2: 151.328,
    y2: 148.541
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 153.949,
    x2: 151.328,
    y2: 153.949
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 159.357,
    x2: 151.328,
    y2: 159.357
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 179.263,
    x2: 146.132,
    y2: 179.263
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 98.319,
    y1: 185.638,
    x2: 146.132,
    y2: 185.638
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 574.471,
    y: 100.164,
    style: {
      fill: "#5C87CC"
    },
    width: 69.5,
    height: 56.432
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 589.175,
    cy: 114.611,
    r: 6.516
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 582.659,
    y1: 131.963,
    x2: 635.668,
    y2: 131.963
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 582.659,
    y1: 137.371,
    x2: 635.668,
    y2: 137.371
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 582.659,
    y1: 142.78,
    x2: 604.721,
    y2: 142.78
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    x1: 582.659,
    y1: 148.188,
    x2: 635.668,
    y2: 148.188
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8281 -0.5606 0.5606 0.8281 -17.4125 221.3395)",
    style: {
      fill: "#89ADF2"
    },
    cx: 352.159,
    cy: 139.058,
    rx: 18.305,
    ry: 18.305
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 352.159,
    y1: 120.753,
    x2: 352.159,
    y2: 157.363
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M321.548,126.293c-8.823-10.181-17.647,5.599-17.647,5.599s-8.823-15.78-17.647-5.599 c-9.164,10.574,17.647,27.828,17.647,27.828S330.712,136.867,321.548,126.293z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 280.926,179.513 290.84,179.513 294.876,171.076 299.626,189.27 305.126,162.263 311.876,196.263 316.376,179.263  326.876,179.263  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 266.504,
    y1: 146.922,
    x2: 266.504,
    y2: 155.484
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 270.785,
    y1: 151.203,
    x2: 262.223,
    y2: 151.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 328.457,
    y1: 99.77,
    x2: 328.457,
    y2: 108.332
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 332.738,
    y1: 104.051,
    x2: 324.176,
    y2: 104.051
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 404.072,
    y1: 181.281,
    x2: 404.072,
    y2: 189.843
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 408.353,
    y1: 185.562,
    x2: 399.79,
    y2: 185.562
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 624.015,
    y1: 170.349,
    x2: 624.015,
    y2: 178.911
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 628.297,
    y1: 174.63,
    x2: 619.734,
    y2: 174.63
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 129.632,
    y1: 222.107,
    x2: 129.632,
    y2: 230.669
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 133.913,
    y1: 226.388,
    x2: 125.35,
    y2: 226.388
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 354.691,
    y1: 217.97,
    x2: 354.691,
    y2: 223.806
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 357.609,
    y1: 220.888,
    x2: 351.773,
    y2: 220.888
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 475.007,
    y1: 90.44,
    x2: 475.007,
    y2: 96.276
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 477.924,
    y1: 93.358,
    x2: 472.089,
    y2: 93.358
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 375.882,
    y1: 58.807,
    x2: 375.882,
    y2: 64.642
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 378.799,
    y1: 61.725,
    x2: 372.964,
    y2: 61.725
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 176.348,
    y1: 148.286,
    x2: 176.348,
    y2: 154.121
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 179.266,
    y1: 151.203,
    x2: 173.43,
    y2: 151.203
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 593.059,
    y1: 197.533,
    x2: 593.059,
    y2: 203.368
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C87CC",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 595.977,
    y1: 200.451,
    x2: 590.141,
    y2: 200.451
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M421.72,119.97l21.25-6.799v55.299c0,0-21.25-6.338-21.25-23.669 C421.72,127.47,421.72,119.97,421.72,119.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M464.22,119.97l-21.25-6.799v55.299c0,0,21.25-6.338,21.25-23.669 C464.22,127.47,464.22,119.97,464.22,119.97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "453.882,137.808 445.97,137.808 445.97,129.896 439.97,129.896 439.97,137.808  432.058,137.808 432.058,143.808 439.97,143.808 439.97,151.72 445.97,151.72 445.97,143.808 453.882,143.808  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C87CC"
    },
    cx: 367.823,
    cy: 93.358,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M170.68,70.369c0,2.473-2.005,4.477-4.477,4.477c-2.473,0-4.477-2.005-4.477-4.477 c0-2.473,2.005-4.477,4.477-4.477C168.675,65.892,170.68,67.896,170.68,70.369z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C87CC"
    },
    cx: 133.913,
    cy: 83.163,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M424.75,71.875c0,2.572-2.085,4.658-4.658,4.658s-4.658-2.085-4.658-4.658 c0-2.573,2.085-4.658,4.658-4.658S424.75,69.302,424.75,71.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M640.326,208.326c0,2.572-2.085,4.658-4.658,4.658c-2.573,0-4.658-2.085-4.658-4.658 c0-2.573,2.085-4.658,4.658-4.658C638.24,203.668,640.326,205.753,640.326,208.326z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89ADF2"
    },
    cx: 98.319,
    cy: 223.806,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89ADF2"
    },
    cx: 660.915,
    cy: 175.907,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M121.588,261.217c0,2.691-2.182,4.873-4.873,4.873c-2.691,0-4.873-2.182-4.873-4.873 c0-2.691,2.182-4.873,4.873-4.873C119.407,256.345,121.588,258.526,121.588,261.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C87CC"
    },
    d: "M324.363,214.607c0,1.458-1.182,2.64-2.64,2.64c-1.458,0-2.64-1.182-2.64-2.64 s1.182-2.64,2.64-2.64C323.181,211.967,324.363,213.149,324.363,214.607z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89ADF2"
    },
    cx: 338.989,
    cy: 324.999,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89ADF2"
    },
    cx: 444.332,
    cy: 93.636,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89ADF2"
    },
    cx: 586.871,
    cy: 80.388,
    r: 4.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C87CC"
    },
    cx: 554.395,
    cy: 67.217,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5C87CC"
    },
    cx: 370.464,
    cy: 294.623,
    r: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M308.827,76.508c0,2.559-2.074,4.633-4.633,4.633c-2.559,0-4.633-2.074-4.633-4.633 s2.074-4.633,4.633-4.633C306.752,71.875,308.827,73.949,308.827,76.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M418.327,281.091c0,2.559-2.074,4.633-4.633,4.633c-2.559,0-4.633-2.074-4.633-4.633 c0-2.559,2.074-4.633,4.633-4.633C416.253,276.458,418.327,278.533,418.327,281.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M390.954,341.021c0,2.559-2.074,4.633-4.633,4.633c-2.559,0-4.633-2.074-4.633-4.633 c0-2.559,2.074-4.633,4.633-4.633C388.88,336.388,390.954,338.462,390.954,341.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89ADF2"
    },
    d: "M429.358,179.263c0,2.559-2.074,4.633-4.633,4.633c-2.559,0-4.633-2.074-4.633-4.633 c0-2.559,2.074-4.633,4.633-4.633C427.284,174.63,429.358,176.704,429.358,179.263z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.726f33bdfbbb496ff6158b9fdf40300d.svg";
export { ForwardRef as ReactComponent };